<template>
    <div>
        <div class="toolsb">
            <el-button style="margin-right: 10px" type="primary" @click="goBackTap">返回上一页</el-button>
            <el-input class="mb-input" placeholder="请输入学员姓名" v-model="userName"></el-input>
            <el-button type="primary" @click="getListRecord(1)">搜索</el-button>
            <el-button type="primary" @click="resetQueryB">重置</el-button>
            <el-button type="primary" @click="handleAdd">审批线下学员成绩</el-button>
        </div>
        <el-table ref="multipleTable" :data="records" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle">
            <el-table-column prop="nickName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="inspectionTime" label="时间" align="center"></el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mb-pagination"
            @current-change="handleCurrentChangeB"
            :current-page="curPageB"
            layout="total, prev, pager, next"
            :total="totalB">
        </el-pagination>
        <el-dialog title="选择学员" :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div class="toolsb">
                <el-input class="mb-input" placeholder="请输入学员姓名" v-model="keyword"></el-input>
                <el-button type="primary" @click="queryData(1)">搜索</el-button>
                <el-button type="primary" @click="resetQuery">重置</el-button>
            </div>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle">
                <el-table-column prop="nickName" label="姓名" align="center"></el-table-column>
                <el-table-column prop="phonenumber" label="手机号码" align="center"></el-table-column>
                <el-table-column prop="workType" label="工种" align="center" width="200"></el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handlePass(scope.$index, scope.row, 1)">通过</el-button>
                        <el-button type="text" @click="handlePass(scope.$index, scope.row, 0)">不通过</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="mb-pagination"
                @current-change="handleCurrentChange"
                :current-page="curPage"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import CommonStyle from "@/utils/CommonStyle";
    export default {
        name: "OfflineScore",
        components: {},
        data() {
            return {
                tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
                tableData: [],
                records: [],
                query: {},
                curPage: 1,
                total: 0,
                keyword: "",
                userName: "",
                classIdList: [],
                assesmentId: 0,
                dialogVisible: false,

                curPageB: 1,
                totalB: 0
            }
        },
        mounted() {
            let that = this;
            that.classIdList = that.$route.query.classIdList;
            that.assesmentId = that.$route.query.assesmentId;
            that.getListRecord(1);
        },
        methods: {
            getListRecord(curPageB) {
                let that = this;
                that.HttpConnection.get("/learn/record/listRecord", {
                    params: {
                        classerId: that.classIdList[0],
                        userName: that.userName,
                        pageSize: 10,
                        pageNum: curPageB,
                    }
                }).then(function(response) {
                    that.records = response.rows;
                    that.totalB = response.total;
                });
            },
            queryData(curPage) {
                let that = this;
                that.HttpConnection.get("/system-user/class/list", {
                    params: {
                        pageSize: 10,
                        pageNum: curPage,
                        keyword: that.keyword,
                        classerId: that.classIdList[0]
                    }
                }).then(function(response) {
                    that.tableData = response.rows;
                    that.total = response.total;
                });
            },
            resetQuery() {
                this.keyword = "";
                this.queryData(1);
            },
            resetQueryB(){
                this.userName = "";
                this.getListRecord(this.curPageB);
            },
            handleAdd(formInfo) {
                let that = this;
                that.dialogVisible = true;
                that.queryData(1);
            },
            goBackTap() {
                this.$router.back(-1);
            },
            handleCurrentChange(val){
                this.curPage = val;
                this.queryData(val);
            },
            handleCurrentChangeB() {
                this.curPageB = val;
                that.getListRecord(val);
            },
            handlePass(index, row, type) {
                let that = this;
                that.HttpConnection.post("/learn/record/saveRecord", {
                    assesmentId: that.assesmentId,
                    records: [
                        {
                            userId: row.userId,
                            isPass: type
                        }
                    ]
                }).then(function(response) {
                    that.$message.success("操作成功");
                    that.getListRecord(that.curPageB);
                }).catch(function(error) {
                    that.$message.error("可能有重复的人员被通过");
                });
            },
            handleDelete(index, row) {
                let that = this;
                that.HttpConnection.delete("/learn/record/deleteRecord/" + row.assesmentRecordId).then(function(response) {
                    that.$message.success("操作成功");
                    that.getListRecord(that.curPageB);
                });
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
